import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_generate_serials_payloadService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { quantity?: number, packaging_name?: string, packaging_short_name?: string, net_weight?: number, gross_weight?: number, weight_uom?: string, net_volume?: number, gross_volume?: number, volume_uom?: string, udfs?: $frontendTypes.FootprintEdi.UserDefinedField[], notes?: string }): Promise<{ SerialNumbers?: $frontendTypes.FootprintEdi.SerialNumber[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

